module.exports = __webpack_public_path__ + "static/img/hair_12.d56b173.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_12.png
// module id = 6ULg
// module chunks = 0